module.exports = __webpack_public_path__ + "static/media/smallMotorcycle.def28d1d.png";